import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import Editor from '@studionand/ada-next/src/legacy/Editor';
import atomicBlockServices from '../../editor/atomicBlockServices';
import inlineStyleServices from '../../editor/inlineStyleServices';
import pluginsConfig from '../../editor/plugins';
import Wrap from '../sections/Wrap';
import useGlobalStyles from '../../editor/useGlobalStyles';
import theme from './theme';

const DepvEditor = props => {
  useGlobalStyles();
  return (
    <ThemeProvider theme={theme}>
      <Wrap maxWidth={800}>
        <Editor
          page={props.page}
          plugins={pluginsConfig}
          customStyleMap={{
            CODE: { fontFamily: '"Source Code Pro", monospace' },
          }}
          atomicBlockServices={atomicBlockServices}
          inlineStyleServices={inlineStyleServices}
        />
      </Wrap>
    </ThemeProvider>
  );
};

export default DepvEditor;
